// Instant search over the whole published catalog (cached in localStorage by version).
// Fuse (fuzzy matching) is its own small bundle, fetched the first time search opens
let fuseLib = null;
function loadFuse() {
	if (window.Fuse) return Promise.resolve(window.Fuse);
	fuseLib = fuseLib || new Promise((res, rej) => {
		const s = document.createElement("script");
		s.src = (window.darat_store || {}).fuse; s.async = true;
		s.onload = () => (window.Fuse ? res(window.Fuse) : rej(new Error("fuse missing"))); s.onerror = rej;
		document.head.appendChild(s);
	});
	return fuseLib;
}
import { $, api, esc, isAr, money, showPrices, store, t } from "./util";

let fuse = null, items = null, loading = null;
const AR = { "أ": "ا", "إ": "ا", "آ": "ا", "ة": "ه", "ى": "ي", "ـ": "" };
const norm = (s) => String(s || "").toLowerCase().replace(/[ً-ْ]/g, "").replace(/[أإآةىـ]/g, (c) => AR[c])
	.replace(/[٠-٩]/g, (d) => d.charCodeAt(0) - 0x660).replace(/[۰-۹]/g, (d) => d.charCodeAt(0) - 0x6f0);
// part-number form, same as the server's catalog.compact: "L19-C3PD6" / "l19 c3pd6" -> "l19c3pd6"
const compact = (s) => norm(s).replace(/[^0-9a-z\u0600-\u06ff]+/g, "");
const isPn = (cq) => cq.length >= 3 && /\d/.test(cq);
function partMatch(i, q) {
	const cq = compact(q);
	if (!isPn(cq)) return "";
	return [...(i.m || []), i.c].find((m) => { const cm = compact(m); return cm.includes(cq) || (cm.length >= 4 && cq.includes(cm)); }) || "";
}
const ALIASES = { "بطاريه": "battery", "بطاريات": "battery", "شاحن": "adapter", "شواحن": "adapter", "كيبورد": "keyboard", "شاشه": "screen", "رام": "ram", "هارد": "hard disk", "مروحه": "fan", "ديل": "dell", "اتش": "hp", "لينوفو": "lenovo", "اسوس": "asus", "ايسر": "acer", "توشيبا": "toshiba", "سوني": "sony", "ابل": "apple", "ماك": "macbook", "سامسونج": "samsung", "هواوي": "huawei", "محول": "adapter", "باور": "adapter", "شاشات": "screen", "رامات": "ram", "ذاكره": "ram",
	"هاردسك": "hard disk", "مراوح": "fan", "كيبوردات": "keyboard", "لوحه": "keyboard", "مفصلات": "hinges", "فلاش": "flash", "كابل": "cable",
	"charger": "adapter", "chargers": "adapter", "adaptor": "adapter", "power": "adapter", "batteries": "battery", "batery": "battery",
	"battary": "battery", "keyboards": "keyboard", "keybord": "keyboard", "keyboad": "keyboard", "display": "screen", "lcd": "screen",
	"led": "screen", "panel": "screen", "screens": "screen", "memory": "ram", "sodimm": "ram", "hdd": "hard disk", "fans": "fan", "hinge": "hinges",
	"إتش": "hp", "أسوس": "asus", "أيسر": "acer", "أبل": "apple" };
// filler words that never appear in item names (same list as the server)
const STOP = new Set(["laptop", "laptops", "notebook", "for", "my", "the", "of", "لابتوب", "للابتوب", "اللابتوب", "جهاز", "لجهاز", "جهازي", "قطعه", "قطع", "غيار", "ل", "حق", "مال", "الى", "في"]);

async function load() {
	if (fuse) return fuse;
	loading = loading || (async () => {
		const cached = store("darat_idx");
		let data = cached;
		try {
			const fresh = await api("darat.storefront.api.search_index");
			data = fresh;
			store("darat_idx", fresh);
		} catch (e) { if (!data) throw e; }
		items = data.items.map((i) => ({ ...i, _h: norm([i.c, i.n, i.a, i.b, i.g, (i.m || []).join(" ")].join(" ")),
			_hc: [i.c, ...(i.m || [])].map(compact).join(" ") }));
		groups = data.groups || [];
		const Fuse = await loadFuse();
		fuse = new Fuse(items, { keys: [{ name: "m", weight: 3 }, { name: "c", weight: 2 }, { name: "n", weight: 2 }, { name: "a", weight: 1.5 }, { name: "b", weight: 1 }], threshold: 0.34, ignoreLocation: true, minMatchCharLength: 2 });
		return fuse;
	})();
	return loading;
}

function find(q) {
	const raw = norm(q).split(/\s+/).filter(Boolean);
	const kept = raw.filter((w) => !STOP.has(w));
	const words = (kept.length ? kept : raw).map((w) => ALIASES[norm(w)] || ALIASES[w] || w);
	const cq = compact(q), pn = isPn(cq);
	let exact = items.filter((i) => words.every((w) => i._h.includes(w) || (/\d/.test(w) && i._hc.includes(compact(w)))) || (pn && i._hc.includes(cq)));
	if (pn) exact.sort((a, b) => !!partMatch(b, q) - !!partMatch(a, q));
	exact.sort((a, b) => (b.q > 0) - (a.q > 0));
	if (exact.length >= 8) return exact;
	const seen = new Set(exact.map((i) => i.c));
	const fuzzy = fuse.search(words.join(" "), { limit: 20 }).map((r) => r.item).filter((i) => !seen.has(i.c));
	return exact.concat(fuzzy);
}

function hi(text, q) {
	const s = esc(text);
	const w = q.trim().split(/\s+/).filter((x) => x.length > 1).map((x) => x.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));
	return w.length ? s.replace(new RegExp(`(${w.join("|")})`, "gi"), "<mark>$1</mark>") : s;
}

export function resultRow(i, q = "") {
	const name = isAr && i.a ? i.a : i.n;
	const pm = q ? partMatch(i, q) : "";
	return `<a class="ds-sr" href="/p/${esc(i.u)}">
		<span class="ds-sr__img">${i.i || i.ri ? `<img src="${esc(i.i || i.ri)}" alt="" loading="lazy">` : `<svg viewBox="0 0 160 120"><use href="#part-${esc(i.ic || "generic")}"/></svg>`}</span>
		<span class="ds-sr__body"><b>${hi(name, q)}</b><small dir="ltr">${esc(i.c)}${i.m && i.m.length ? " · " + hi(i.m.slice(0, 3).join(", "), q) : ""}</small>${pm ? `<small class="ds-sr__match">${t("يطابق الرقم", "Matches part no.")} <b dir="ltr">${esc(pm)}</b></small>` : ""}</span>
		<span class="ds-sr__price">${i.q <= 0 ? `<small class="ds-muted">${t("غير متوفر", "Out of stock")}</small>` : showPrices ? money(i.p) : ""}</span></a>`;
}

const RS = "darat_recent_q";
function remember(q) { q = (q || "").trim(); if (q.length < 2) return; store(RS, [q, ...(store(RS) || []).filter((x) => x !== q)].slice(0, 6)); paintRecent(); }
function paintRecent() {
	const box = document.querySelector("[data-recent-searches]"), list = document.querySelector("[data-recent-list]");
	const r = store(RS) || [];
	if (!box) return;
	box.hidden = !r.length;
	list.innerHTML = r.map((q) => `<button type="button" class="ds-chip" data-q="${esc(q)}" dir="auto">${esc(q)}</button>`).join("");
}
let groups = [], brands = [];
function suggestions(q) {
	const n = norm(q);
	const g = groups.filter((x) => norm(x.ar).includes(n) || norm(x.en).includes(n)).slice(0, 3);
	const bset = new Set(); items.forEach((i) => i.b && bset.add(i.b));
	const b = [...bset].filter((x) => x.toLowerCase().startsWith(n)).slice(0, 3);
	if (!g.length && !b.length) return "";
	return `<div class="ds-sugg">${g.map((x) => `<a class="ds-chip" href="/shop/${esc(x.s)}">${isAr ? esc(x.ar) : esc(x.en)}</a>`).join("")}${b.map((x) => `<a class="ds-chip" href="/brand/${encodeURIComponent(x)}">${esc(x)}</a>`).join("")}</div>`;
}

export function initSearch() {
	paintRecent();
	const input = $("[data-search-input]");
	const out = $("[data-search-results]");
	if (!input || !out) return;
	document.addEventListener("darat:open", (e) => { if (e.detail === "search") load().catch(() => {}); });
	let active = -1, timer, missTimer;
	input.addEventListener("input", () => {
		clearTimeout(timer);
		clearTimeout(missTimer);
		timer = setTimeout(async () => {
			const q = input.value.trim();
			active = -1;
			if (q.length < 2) { out.innerHTML = ""; const idle = document.querySelector("[data-search-idle]"); if (idle) idle.hidden = false; return; }
			try { await load(); } catch (e) { return; }
			const res = find(q);
			out.innerHTML = suggestions(q) + (res.length
				? res.slice(0, 8).map((i) => resultRow(i, q)).join("") + `<a class="ds-sr__all" href="/shop?q=${encodeURIComponent(q)}">${t(`عرض كل النتائج (${res.length})`, `See all results (${res.length})`)}</a>`
				: `<p class="ds-sr__all ds-muted">${t("لا توجد نتائج. جرّب رقم القطعة أو راسلنا على واتساب", "No results — try the part number or WhatsApp us")}
					<a href="/part-number">${t("أين أجد رقم القطعة؟", "Where do I find the part number?")}</a></p>`);
			const idle = document.querySelector("[data-search-idle]"); if (idle) idle.hidden = true;
			// once typing has settled: report the search (analytics) and log it for staff if nothing matched
			clearTimeout(missTimer);
			missTimer = setTimeout(() => {
				if (input.value.trim() !== q) return;
				try { (window.dataLayer = window.dataLayer || []).push({ event: "search", search_term: q, results: res.length }); } catch (e) { /* analytics optional */ }
				if (!res.length && q.length >= 3) api("darat.storefront.api.search_miss", { q }, "POST").catch(() => {});
			}, 1500);
		}, 90);
	});
	input.form?.addEventListener("submit", () => remember(input.value));
	out.addEventListener("click", () => remember(input.value));
	document.addEventListener("click", (e) => {
		const chip = e.target.closest("[data-q]");
		if (chip) { input.value = chip.dataset.q; input.dispatchEvent(new Event("input", { bubbles: true })); input.focus(); }
		if (e.target.closest("[data-clear-recent]")) { store(RS, []); paintRecent(); }
	});
	input.addEventListener("keydown", (e) => {
		const rows = out.querySelectorAll(".ds-sr");
		if (!rows.length || !["ArrowDown", "ArrowUp", "Enter"].includes(e.key)) return;
		if (e.key === "Enter" && active >= 0) { e.preventDefault(); rows[active].click(); return; }
		if (e.key === "Enter") return;
		e.preventDefault();
		active = (active + (e.key === "ArrowDown" ? 1 : -1) + rows.length) % rows.length;
		rows.forEach((r, i) => r.classList.toggle("is-active", i === active));
		rows[active].scrollIntoView({ block: "nearest" });
	});
}

export { load as loadIndex, find as findItems };
